import { useState } from 'react';

import BottomSheet from '@rio-cloud/rio-uikit/BottomSheet';
import useLocalStorage from '@rio-cloud/rio-uikit/useLocalStorage';
import Checkbox from '@rio-cloud/rio-uikit/Checkbox';
import { FormattedMessage } from 'react-intl';
import whatsNewBg from '../assets/images/whatsnew-bg.webp';
import { useCustomIntl } from '../i18n/i18n';

type WhatsNewProps = {
  articleId?: string;
  link?: string;
};

/**
 * Shows a bottom sheet with the latest "What's New" article.
 *
 * See the "What's New announcements" section in the README for more details.
 */
export const WhatsNew = ({ articleId, link }: WhatsNewProps) => {
  const intl = useCustomIntl();

  const [dismissedArticleId, setDismissedArticleId] = useLocalStorage<
    string | null
  >('whatsnew-dismissed-id', null);

  const [showBottomSheet, setShowBottomSheet] = useState(
    !!articleId && dismissedArticleId !== articleId,
  );

  return (
    <BottomSheet
      show={showBottomSheet}
      onClose={() => setShowBottomSheet(false)}
      detach
      bodyClassName="padding-25 padding-top-50 max-width-450"
    >
      <div data-testid="whatsnew-bottom-sheet">
        <div
          style={{ color: 'white' }}
          className="position-relative"
        >
          <img
            alt={intl.formatMessage({
              id: 'common.news',
            })}
            src={whatsNewBg}
            className="width-100pct"
          />
          <div
            style={{
              // custom styling for precise positioning on top of background image
              bottom: '55px',
            }}
            className="position-absolute left-25 text-size-h2"
          >
            <FormattedMessage id="common.news" />
          </div>
          <div className="position-absolute left-25 bottom-10 text-size-h1 text-bold">
            SimplePay
          </div>
        </div>
        <p className="text-size-h5 text-bold">
          <FormattedMessage id="whatsnew.title" />
        </p>
        <p>
          <FormattedMessage id="whatsnew.body" />
        </p>
        <div className="btn-toolbar margin-top-15 display-flex justify-content-between align-items-center">
          <span data-testid="whatsnew-dont-show-again">
            <Checkbox
              onChange={(e) => {
                if (e.target.checked) {
                  setDismissedArticleId(articleId);
                  setShowBottomSheet(false);
                }
              }}
            >
              <FormattedMessage id="common.action.dontShowThisAgain" />
            </Checkbox>
          </span>
          {link && (
            <button
              type="button"
              data-testid="whatsnew-read-more"
              className="btn btn-primary"
              onClick={() => window.open(link, '_blank', 'noopener')}
            >
              <span className="rioglyph rioglyph-detail-view-info" />
              <FormattedMessage id="common.action.readMore" />
            </button>
          )}
        </div>
      </div>
    </BottomSheet>
  );
};
